/**
 * Gets the value of the given cookie.
 *
 * @param name - Key of the cookie.
 * @returns {string}
 */
export const getCookieValue = (name: string) =>
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';

export const deleteCookie = (name: string) => {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.${window.location.hostname}`;
};
